import { FeeCalculationScenario, ProductFeeType } from '@shared/constants/product-fees';
import { BridgingProductFeeTypeModal, ProductFeeStructure, WhenPayableCustom, WhenRefundable } from '@shared/models';
import { LendingType } from '@usermanager/models/tariff-of-charges';

export interface CustomProductFees {
  feeName: string;
  feeType: ProductFeeType;
  feeCalculationScenario: FeeCalculationScenario;
  canOverride: boolean;
}

export interface CustomBridgingProductFees {
  feeName: BridgingProductFeeTypeModal;
  feeCalculationScenario: FeeCalculationScenario;
  canOverride: boolean;
}

export interface CustomFee {
  id: number;
  addToLoan: boolean;
  amountRefundable: number;
  feeAmount: number;
  feeStructure: ProductFeeStructure;
  type: ProductFeeType;
  feeName: string;
  customFeeName: string;
  whenPayable: WhenPayableCustom;
  whenRefundable: WhenRefundable;
  payableTo: string;
  lendingTypeId: number | null;
  isFirmApplied?: boolean;
  mortgageTypePurchase: boolean;
  mortgageTypeRemortgage: boolean;
  mortgageTypeProductTransfer: boolean;
  mortgageTypeSecondCharge: boolean;
}

export interface CustomProductCalculations {
  assumedLegalFeeCost: number;
  customFeeCalculationScenarios: CustomProductFees[];
  customTrueCostPeriod: number | null;
  deductCashback: boolean;
  isDeductCashbackOverridable: boolean;
  customFees: CustomFee[];
  areCustomFeesOverridable: boolean | null;
  distributionGroupId?: number | null;
  userId?: string | null;
  isAssumedLegalFeeAppliedAtFirmLevel?: boolean;
  supportedLendingTypes: LendingType[];
}

export interface CustomProductCalculationsFormModel {
  assumedLegalFeeCost: number;
  customFeeCalculationScenarios: CustomProductFees[];
  deductCashback: boolean;
  isDeductCashbackOverridable: boolean;
  customFees: (CustomFee & { feeAmountPct: number })[];
  areCustomFeesOverridable: boolean | null;
  distributionGroupId?: number | null;
  userId?: string | null;
  isAssumedLegalFeeAppliedAtFirmLevel?: boolean;
  supportedLendingTypes: LendingType[];
}

export interface CustomBridgingProductCalculations {
  customFeeCalculationScenarios: CustomBridgingProductFees[];
}

export interface CustomFeeDisplayModel {
  type: ProductFeeType;
  customName: string;
  displayName: string;
  isCustom: boolean;
}

export enum MortgageTypeValues {
  ProductTransfer = 'productTransfer',
  Purchase = 'purchase',
  Remortgage = 'remortgage',
  SecondCharge = 'secondCharge',
}

export const mortgageTypeOptions = [
  { value: MortgageTypeValues.ProductTransfer, label: 'Product transfer' },
  { value: MortgageTypeValues.Purchase, label: 'Purchase' },
  { value: MortgageTypeValues.Remortgage, label: 'Remortgage' },
  { value: MortgageTypeValues.SecondCharge, label: 'Second Charge' },
];
